// extracted by mini-css-extract-plugin
export var clearSearch = "header-module--clearSearch--33cfe";
export var container = "header-module--container--5cb9d";
export var header = "header-module--header--666b3";
export var headerLite = "header-module--headerLite--4ea6c";
export var logo = "header-module--logo--9932e";
export var nav = "header-module--nav--7bc38";
export var searchForm = "header-module--searchForm--592e8";
export var searchIcon = "header-module--searchIcon--13827";
export var searchInput = "header-module--searchInput--64dd4";